import VueMq from 'vue-mq'
import { t, timage } from './utils/i18n';
import './services/queryParams';
import './services/ipqs';
import './services/fingerprintjs2';
import './UIsettings';

Vue.config.productionTip = false

// setup logowl to catch errors
Vue.config.errorHandler =(err, vm, info) => {
  console.log(err)
  window.logowl && window.logowl.emitError(err);
};
// logowl cant emit warnings for now
// Vue.config.warnHandler = (err, vm, info) => {
//   window.logowl && window.logowl.emitError(err);
// };

Vue.prototype.$t = t;
Vue.prototype.$timage = timage;

Vue.use(VueMq, {
  breakpoints: {
    xs: 375,
    s: 768,
    m: 960,
    l: 1120,
    xl: 1280,
    xxl: Infinity
  }
})
